import React from 'react'
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native'
import { createNativeStackNavigator, NativeStackNavigationProp } from '@react-navigation/native-stack'
import { FinalStep, ForgotPassword, Login, Register, RegistrationSteps, ResetPassword, Welcome } from '@screens'
import { FullRegistrationData } from '@hooks'

export type ScreenAuthProps<RouteName extends keyof AuthStackParamList> = {
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<AuthStackParamList, RouteName>,
    NativeStackNavigationProp<AuthStackParamList, keyof AuthStackParamList>
  >
  route: RouteProp<AuthStackParamList, RouteName>
}

export type AuthStackParamList = {
  Welcome: undefined
  Login: undefined
  Register: undefined
  ForgotPassword: { token?: string }
  ResetPassword: { token?: string }
  RegistrationSteps: undefined
  FinalStep: undefined
}

const AuthStack = createNativeStackNavigator<AuthStackParamList>()

export const AuthNavigator = () => {
  return (
    <AuthStack.Navigator screenOptions={{ headerShown: false }} initialRouteName="Welcome">
      <AuthStack.Screen name="Welcome" component={Welcome} />
      <AuthStack.Screen name="Login" component={Login} />
      <AuthStack.Screen name="Register" component={Register} />
      <AuthStack.Screen name="ForgotPassword" component={ForgotPassword} />
      <AuthStack.Screen name="ResetPassword" component={ResetPassword} />
      <AuthStack.Screen
        name="RegistrationSteps"
        component={RegistrationSteps}
      />
      <AuthStack.Screen
        name="FinalStep"
        component={FinalStep}
        options={{ gestureEnabled: false }}
      />
    </AuthStack.Navigator>
  )
}
